module.exports = __webpack_public_path__ + "img/bg_m.033bd8b6.jpg";